<div class="mx-20 mt-10 pb-5 flex-grow">
  <div class="flex items-center text-3xl text-black">
    <p>
      Welcome back, @if (!isLoading) {
      <b>{{firstName}}!</b>
    }
  </p>
  @if (isLoading) {
    <div class="ml-2 animate-pulse bg-gray-200 w-[150px] h-6 rounded"></div>
  }
</div>
<div [style]="messageBoxStyle">
  <div class="flex py-8 mt-3 px-3 items-center" id="banner">
    <button aria-label="Decrement Dashboard Message" [disabled]="studentMessageIter === 0" (click)="decrementMessages()" [ngClass]="studentMessageIter !== 0? 'flex-shrink justify-self-start text-white h-8 w-8 rounded-full flex justify-center items-center': 'flex-shrink justify-self-start text-transparent h-8 w-8 rounded-full flex justify-center items-center'">
      <fa-icon [icon]="faChevronLeft" />
    </button>
    <div class="flex-grow ml-3 text-lg">
      @if (studentMessages.length > 0) {
        <div class="sm:max-w-[200px] lg:max-w-[650px] max-h-[150px] line-clamp-2">
          {{studentMessages[studentMessageIter].msg}}
        </div>
      }
      @if (studentMessages.length === 0) {
        <div class="sm:max-w-[200px] lg:max-w-[650px] max-h-[150px] line-clamp-2">
          No announcements!
        </div>
      }
      @if (studentMessages.length > 1) {
        <div class="flex -mb-5">
          @for (message of studentMessages; track message; let i = $index) {
            <button (click)="studentMessageIter = i" [ngClass]="studentMessageIter === i? 'rounded-full h-2 w-2 bg-gray-600 mr-1 mt-8': 'rounded-full h-2 w-2 bg-gray-200 mr-1 mt-8'">
            </button>
          }
        </div>
      }
    </div>
    @if (studentMessageIter !== studentMessages.length-1 && studentMessages.length !== 0) {
      <button (click)="incrementMessages()" class="flex-shrink justify-self-end text-black h-8 w-8 rounded-full flex justify-center items-center hover:bg-gray-200">
        <fa-icon [icon]="faChevronRight" />
      </button>
    }
  </div>
</div>
<p class="text-xl mt-5"><b>Placement Exams</b></p>
<div class="grid grid-cols-4 w-full mt-10 text-center font-bold bg-gray-100 rounded-[4px] py-3">
  <div class="col-span-2">
    Exam Name
  </div>
  <div>
    Status
  </div>
  <!--<div>
    Requirement
  </div>-->
  <div>
    Action
  </div>
</div>
@if (isLoadingList) {
  <div class="mt-3">
    @for (temp of [].constructor(3); track temp) {
      <div class="grid grid-cols-4 w-full mt-3 text-center mt-1 h-[40px]">
        <div class="col-span-2 mx-1">
          <div class="animate-pulse rounded bg-gray-200 w-full h-full"></div>
        </div>
        <div class="mx-1">
          <div class="animate-pulse rounded bg-gray-200 w-full h-full"></div>
        </div>
        <div class="mx-1">
          <div class="animate-pulse rounded bg-gray-200 w-full h-full"></div>
        </div>
      </div>
    }
  </div>
}
@if (!isLoadingList) {
  <div class="mt-3">
    @if (englishNBExamResponse != null) {
      <div class="grid grid-cols-4 w-full text-center mt-2 min-h-[40px]">
        <div class="col-span-2 flex justify-center items-center">
          {{englishNBExamResponse.exam_title}}
        </div>
        <div class="flex justify-center items-center">
          {{ statusFormatterPipe.transform(englishNBExamResponse.status) }}
        </div>
        <!--<div class="flex justify-center items-center">
          Required
        </div>-->
        <div>
          @if (englishNBExamResponse.status  === 'ready_to_start') {
            <full-button text="Take Exam" (click)="startExam(englishNBExamResponse.exam_id)" [fullWidth]="true" />
          }
          <!-- TODO For placement the students are not allowed to resume a test. They can only start it. This means Jennifer will have to go and reset their exam fully for them to try again -->
          @if (englishNBExamResponse.status  === 'in_progress') {
            <full-button
              [disabled]="!englishNBExamResponse.can_resume"
              text="Resume Exam"
              (click)="resumeExam(englishNBExamResponse.exam_uuid, englishNBExamResponse.exam_id)"
              [fullWidth]="true"
            />
          }
          @if (englishNBExamResponse.status  !== 'ready_to_start'
          && englishNBExamResponse.status  !== 'in_progress'
          && englishNBExamResponse.status !== 'scored') {
            <full-button text="No Action" [disabled]="true" [fullWidth]="true" />
          }
          @if (englishNBExamResponse.status === 'scored') {
            <full-button [fullWidth]="true" [disabled]="true" text="Completed" />
          }
        </div>
      </div>
      <hr class="my-3"/>
    }
    @for (exam of examListResponse; track exam; let i = $index) {
      <div [ngClass]="i%2 === 0? 'grid grid-cols-4 w-full text-center mt-2 min-h-[40px]': 'grid grid-cols-4 w-full text-center mt-2 rounded-[8px] bg-gray-100 min-h-[40px]'">
        <div class="col-span-2 flex justify-center items-center">
          {{exam.exam_title}}
        </div>
        <div class="flex justify-center items-center">
          {{ statusFormatterPipe.transform(exam.status) }}
        </div>
        <!--<div class="flex justify-center items-center">
          Required
        </div>-->
        <div>
          @if (exam.status  === 'ready_to_start') {
            <full-button text="Take Exam" (click)="startExam(exam.exam_id)" [fullWidth]="true" />
          }
          <!-- TODO For placement the students are not allowed to resume a test. They can only start it. This means Jennifer will have to go and reset their exam fully for them to try again -->
          @if (exam.status  === 'in_progress') {
            <full-button [disabled]="!exam.can_resume" text="Resume Exam" (click)="resumeExam(exam.exam_uuid, exam.exam_id)" [fullWidth]="true"/>
          }
          @if (exam.status  !== 'ready_to_start' && exam.status  !== 'in_progress' && exam.status !== 'scored' && exam.status !== 'retake_locked') {
            <full-button text="No Action" [disabled]="true" [fullWidth]="true" />
          }
          @if (exam.status === 'scored') {
            @if (exam.score != null) {
              <div>
                Scored: {{exam.score}} out of {{exam.max_score}}
                @if (getGradedParts(exam).length > 0) {
                  <button class="ml-1 text-sm underline hover:opacity-70" [style.color]="primaryColor" (click)="openScoreBreakdown(exam)">
                    View breakdown
                  </button>
                }
                <full-button [fullWidth]="true" [disabled]="true" text="Completed" />
              </div>
            } @else {
              <full-button [fullWidth]="true" [disabled]="true" text="Completed" />
            }
          }
          @if(exam.status === 'retake_locked') {
            <full-button [disabled]="true" [fullWidth]="true" [text]="'Unlocks at ' + (exam.first_start | date:'short')" />
          }
        </div>
      </div>
    }
  </div>
}
<!--
TODO Re-visit optional exams
<p class="text-xl mt-10"><b>Optional</b></p>
<div class="grid grid-cols-5 w-full mt-10 text-center font-bold bg-gray-100 rounded-[4px] py-3">
  <div class="col-span-2">
    Course Name
  </div>
  <div>

  </div>
  <div>
    Requirement
  </div>
  <div>
    Action
  </div>
</div>
<div *ngIf="isLoadingListOptional" class="mt-3">
  <div *ngFor="let temp of [].constructor(3)" class="grid grid-cols-5 w-full mt-3 text-center mt-1">
    <div class="col-span-2 mx-1">
      <div class="animate-pulse rounded bg-gray-200 w-full h-6"></div>
    </div>
    <div class="mx-1">
      <div class="animate-pulse rounded bg-gray-200 w-full h-6"></div>
    </div>
    <div class="mx-1">
      <div class="animate-pulse rounded bg-gray-200 w-full h-6"></div>
    </div>
    <div class="mx-1">
      <div class="animate-pulse rounded bg-gray-200 w-full h-6"></div>
    </div>
  </div>
</div>
<div *ngIf="!isLoadingListOptional" class="my-3">
  <div *ngFor="let exam of optionalListResponse" class="grid grid-cols-5 w-full text-center mt-1">
    <div class="col-span-2">
      {{exam.name}}
    </div>
    <div>

    </div>
    <div>
      Optional
    </div>
    <div>
      <full-button text="Opt In" (click)="optIn()" [fullWidth]="true"/>
    </div>
  </div>
  <div *ngIf="optionalListResponse.length === 0" class="text-center mt-3 pb-5">
    No optional exams
  </div>
</div>
-->
</div>
@if (scoreBreakdownExam) {
  <div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30" (click)="closeScoreBreakdown()">
    <div class="h-full w-full flex justify-center items-center p-4">
      <div class="rounded-[16px] bg-white w-full max-w-[560px] max-h-full overflow-y-auto" (click)="$event.stopPropagation()">
        <div class="flex justify-between items-start px-5 py-4 border-b border-gray-200">
          <div>
            <div class="font-bold">Score Breakdown</div>
            <div class="text-sm text-zinc-500">
              {{getPartsPassed(scoreBreakdownExam)}} of {{getGradedParts(scoreBreakdownExam).length}} parts passed · {{scoreBreakdownExam.score}} / {{scoreBreakdownExam.max_score}} points total
            </div>
          </div>
          <button aria-label="Close" class="text-zinc-500 hover:text-black" (click)="closeScoreBreakdown()">
            <fa-icon [icon]="faXmark" />
          </button>
        </div>
        @if (hasNoJavaExperience(scoreBreakdownExam)) {
          <div class="px-5 py-5">
            <div class="flex items-start gap-3 rounded-lg bg-red-100 text-red-700 p-4">
              <fa-icon [icon]="faXmark" class="mt-1" />
              <div>
                <div class="font-bold">Why you didn't pass</div>
                <div class="mt-1 text-sm">
                  You answered No to "Do you have prior programming experience in Java?" Prior Java experience is required to continue, so the exam ended before Part 1.
                </div>
              </div>
            </div>
            <div class="text-sm text-zinc-500 mt-3">
              Parts 1 to {{getGradedParts(scoreBreakdownExam).length}} were not reached and have no score.
            </div>
          </div>
        } @else {
        <div class="px-5">
          @for (part of getGradedParts(scoreBreakdownExam); track part.part_name; let i = $index) {
            @let state = getPartState(part);
            <div class="py-3" [ngClass]="{'border-t border-gray-200': i > 0, 'opacity-60': state === 'locked'}">
              <div class="flex items-center gap-3">
                <div class="flex-none h-7 w-7 rounded-full flex justify-center items-center text-sm"
                  [ngClass]="{'bg-green-100 text-green-700': state === 'passed', 'bg-red-100 text-red-700': state === 'failed', 'bg-gray-100 text-gray-500': state === 'locked'}">
                  <fa-icon [icon]="state === 'passed' ? faCheck : state === 'failed' ? faXmark : faLock" />
                </div>
                <div class="flex-grow font-medium">{{part.part_name}}</div>
                <span class="text-xs rounded-lg px-2.5 py-1"
                  [ngClass]="{'bg-green-100 text-green-700': state === 'passed', 'bg-red-100 text-red-700': state === 'failed', 'bg-gray-100 text-gray-500': state === 'locked'}">
                  {{state === 'passed' ? 'Passed' : state === 'failed' ? 'Not Passed' : 'Locked'}}
                </span>
              </div>
              <div class="ml-10 mt-2">
                @if (state === 'locked') {
                  <div class="text-xs text-zinc-500">Pass the previous part to unlock.</div>
                } @else {
                  <div class="flex items-center gap-3">
                    <div class="relative flex-grow h-2 bg-gray-100 rounded">
                      <div class="h-full rounded" [ngClass]="state === 'passed' ? 'bg-green-600' : 'bg-red-600'" [style.width.%]="getPercent(part.part_score, part.part_max_score)"></div>
                      <div class="absolute -top-1 w-0.5 h-4 bg-black" [style.left.%]="getPercent(getPassingScore(part), part.part_max_score)"></div>
                    </div>
                    <span class="text-sm font-medium w-14 text-right">{{part.part_score}} / {{part.part_max_score}}</span>
                  </div>
                  <div class="text-xs text-zinc-500 mt-1">Needed: {{getPassingScore(part)}} points to pass</div>
                }
              </div>
            </div>
          }
        </div>
        }
        <div class="flex justify-between items-center gap-3 px-5 py-3 border-t border-gray-200">
          <span class="text-xs text-zinc-500">
            <fa-icon [icon]="faLock" class="mr-1" />You must pass a part to unlock the next one.
          </span>
          <outline-button text="Close" (click)="closeScoreBreakdown()" />
        </div>
      </div>
    </div>
  </div>
}
